import { useContext, useEffect, useState } from 'react'
import { CustomComponentContext, CustomComponentContextType } from '@/utils/contexts/CustomComponentContext'
import { env } from '@/utils/constants/env'
import { axiosInstance } from '@/utils/lib/axios'
import { Dialog, Select } from 'alurkerja-ui'
import { Controller } from 'react-hook-form'

export default function Category() {
  const { setValue, control, taskData } = useContext<CustomComponentContextType>(CustomComponentContext)
  const [loadingCategory, setLoadingCategory] = useState<boolean>(false)
  const [dataCategory, setDataCategory] = useState<{ value: number; label: string }[]>([])

  const classNamesLabel = 'font-medium after:content-["*"] after:text-red-400 after:text-sm'

  useEffect(() => {
    const companyId = taskData?.variables?.company_id_requestor

    const fetchCategory = async () => {
      try {
        setLoadingCategory(true)

        const urlCategory = new URL(env.apiTasklistBaseUrl + '/api/v1/odoo/category?companyId=' + companyId)
        const responseCategory = await axiosInstance.get(urlCategory.toString())
        const optionsCategory = Array.isArray(responseCategory.data.data) ? responseCategory.data.data.map((item: {
          name: string
          id: number
        }) => ({
          value: item.id,
          label: item.name,
        })) : []

        setDataCategory(optionsCategory)
        setLoadingCategory(false)
      } catch (error: any) {
        Dialog.error({
          description: error.response.data.data || 'Error fetching category',
        })
      }
    }

    if (companyId) {
      fetchCategory()
    }
  }, [taskData])

  return (
    <>
      <div className="flex flex-col gap-4">
        <div>
          <label className={classNamesLabel}>
            Category
          </label>
          <Controller
            name={'CATEGORY_ID'}
            control={control}
            rules={{ required: { value: true, message: `Category is Required.` } }}
            render={({ fieldState }) => {
              return (
                <>
                  <Select
                    isDisabled={dataCategory.length < 1}
                    isLoading={loadingCategory}
                    options={dataCategory}
                    onChange={(newValue: any) => {
                      setValue('CATEGORY_ID', newValue.value)
                    }}
                  />
                  {fieldState.error && <p className="text-sm text-red-500">{fieldState.error.message}</p>}
                </>
              )
            }}
          ></Controller>
        </div>
      </div>
    </>
  )
}